export default __webpack_public_path__ + "static/media/Landing_Logo_MovistarArena.2a6dbbb0.png";